import React from 'react';
import classnames from 'classnames';
import {NeuroMessage, GuideProgress, RenderOnlyFor} from '@ignitesales/neuro-application/src/neuro-guide';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';

const Header = ({className}) => {
  const classes = classnames(
    'header',
    className
  );

  return <>
    <header className={classes}>
      <div className="logo">
        <ReactSVG src="/classpath/assets/images/commerce_logo_full.svg" />
      </div>

      <div className="decoration top">
        <div className="circle blue-sm">
        </div>
        <div className="circle green">
        </div>
      </div>

    </header>
  </>;
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
